import { nonNullishValue } from '../helpers';

function isValidNumberForRequest(...args) {
    return args.every((arg) => nonNullishValue(arg) && !Number.isNaN(+arg));
}

export { isValidNumberForRequest };
